import type { LocalePack } from './types.js';

/** German (Deutsch) */
export const de: LocalePack = {
  headerTitle: 'Fotoeditor',
  headerSubtitle: 'Bearbeite dein Bild mit Leichtigkeit',
  applyButton: 'Übernehmen',
  cancelButton: 'Schließen',
  undo: 'Rückgängig',
  redo: 'Wiederherstellen',
  fullscreen: 'Vollbild',
  fit: 'Einpassen',
  zoomTooltip: 'Zoom · +/− · 0 einpassen · 1 100 %',

  emptyStateTitle: 'Bild ablegen oder klicken zum Hochladen',
  emptyStateSubtitle: 'Unterstützt: PNG, JPEG, HEIC',

  calloutLabelText: 'Beschriftung',

  tool: {
    select: 'Auswählen',
    crop: 'Zuschneiden',
    draw: 'Zeichnen',
    eraser: 'Radierer',
    text: 'Text',
    shapes: 'Formen',
    callout: 'Sprechblase',
    filters: 'Filter',
    adjust: 'Anpassen',
    move: 'Bewegen',
    pen: 'Stift',
    zoom: 'Zoom',
    zoomIn: 'Vergrößern',
    zoomOut: 'Verkleinern',
    rotateLeft: 'Links drehen',
    rotateRight: 'Rechts drehen',
    flipH: 'Horizontal spiegeln',
    flipV: 'Vertikal spiegeln',
    reset: 'Zurücksetzen',
  },

  shape: {
    circle: 'Kreis',
    ellipse: 'Ellipse',
    square: 'Quadrat',
    rectangle: 'Rechteck',
    arrow: 'Pfeil',
    polyline: 'Linienpfad',
  },

  filter: {
    none: 'Original',
    grayscale: 'S/W',
    sepia: 'Sepia',
    vintage: 'Vintage',
    cool: 'Kühl',
    warm: 'Warm',
    invert: 'Invertieren',
  },

  props: {
    title: {
      draw: 'Zeichnen',
      eraser: 'Radierer',
      text: 'Text',
      crop: 'Zuschneiden',
      shapes: 'Formen',
      callout: 'Sprechblase',
      filters: 'Filter',
      adjust: 'Anpassen',
      move: 'Bewegen',
    },
    aspectRatio: 'Seitenverhältnis',
    applyCrop: 'Zuschnitt anwenden',
    cancel: 'Abbrechen',
    shape: 'Form',
    preset: 'Voreinstellung',
    resetEffects: 'Effekte zurücksetzen',
    resetAdjustments: 'Anpassungen zurücksetzen',
    deleteSelected: 'Auswahl löschen',
    colors: 'Farben',
    recent: 'Zuletzt',
    customColor: 'Eigene Farbe',
    brushSize: 'Pinselgröße',
    strokeWidth: 'Strichstärke',
    opacity: 'Deckkraft',
    eraserSize: 'Radierergröße',
    fontSize: 'Schriftgröße',
    brightness: 'Helligkeit',
    contrast: 'Kontrast',
    saturation: 'Sättigung',
    blur: 'Weichzeichnen',
    quickActions: 'Schnellaktionen',
    hintMove:
      'Ziehen zum Verschieben · Pinch oder Scrollen zum Zoomen · wähle ein Werkzeug, um zu starten.',
    hintEraser: 'Tippe oder ziehe über eine Annotation, um sie zu entfernen.',
  },
};
